export const getSumFromArray = (array: number[]): number => {
    return array.reduce((sum, value) => {
        sum += value;
        return sum;
    }, 0);
};
